import React, { useState } from 'react';

const API_BASE_URL = import.meta.env.VITE_API_URL;

const BuildingAdminPage = () => {
  const [building, setBuilding] = useState({
    Address: '',
    City: '',
    State: '',
    ZipCode: '',
    Latitude: '',
    Longitude: '',
    BuildingType: '',
    MostLovedFeature: '',
    TotalUnits: '',
    Description: '',
    NeighborhoodID: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBuilding(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/buildings`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(building),
        credentials: 'include'
      });

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      alert('Building created successfully!');
    } catch (error) {
      console.error('Failed to add building:', error);
      alert('Failed to create building.');
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>Manually Add New Building</h2>
      {Object.keys(building).map((key) => (
        <div key={key} style={{ marginBottom: '10px' }}>
          <label style={{ display: 'block' }}>
            {key}
            <input
              name={key}
              type="text"
              value={building[key]}
              onChange={handleChange}
              style={{ width: '300px', padding: '5px' }}
            />
          </label>
        </div>
      ))}
      <button onClick={handleSubmit}>Submit New Building</button>
    </div>
  );
};

export default BuildingAdminPage;
